<template>
  <div>
    <room-list />
  </div>
</template>

<script>
import RoomList from './RoomList.vue'

export default {
  name: 'RoomsIndex',
  components: {
    RoomList
  },
  async mounted () {
    this.$emit('parent-title', this.$t('room.title'))
    try {
      await this.withLoading(async () => {
        const data = await this.$roomService.getRooms()
        this.rooms = data
      }, 'loading')
    } catch (error) {
      // Error is already handled by the global interceptor
      console.log('Component caught error in getRooms:', error)
    }
  }
}
</script>
